import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, Fragment } from 'react';
import { Backdrop } from '@mui/material';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import { FormControlLabel, Switch, Tooltip } from '@mui/material';

import { DashboardsBackOffice } from "../../../components/backgrounds/DashboardsBackoffice";
import { HttpRequest } from '../../../services/httpRequest';
import { SuccessAlert } from '../../../components/alerts/successAlert';
import { ErrorAlert } from '../../../components/alerts/errorAlert';
import { roleUser } from '../../../utils/roleUser';
import { variablesGlobales } from '../../../configs/variables';
import { CobreService } from '../../../services/cobre/cobre.service';
import { calcularFechas } from '../../../components/credits/calculoFechas';
import { ProgressLinear } from '../../../components/progress/progressLinear';
import { LinkIcon, CheckIcon, DocumentMagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { APIClient } from '../../../helpers/api_helper';
import { GET_DATA_BY_GENERATE_PAYMENT_LINK } from '../../../helpers/url_helper';


const randomDate = "01/01/1992";
const apiClient = new APIClient();

export function GenerateCobreLinkPayment() {

    const navigate = useNavigate();
    const [messsageAlert, setMessageAlert] = useState("");
    const [isOpenSuccess, setIsOpenSuccess] = useState();
    const [isOpenError, setIsOpenError] = useState();
    const [viewalert, setViewalert] = useState(false);
    const [formData, setFormData] = useState({
        cellPhone: '',
        email: '',
        amount: '',
        document: '',
        documentType: 'CC',
        expirationDate: moment().format("YYYY-MM-DD"),
        fullName: '',
        description: 'Pago de crédito #',
        references: [],
        notificationMethods: ['ONLINE'],
        redirectUrl: variablesGlobales.urlRedirectCobre,
        enabledPaymentMethods: ["PSE", "BANCOLOMBIA", "NEQUI"],
        currency: 'COP'
    });
    const [novation, setNovation] = useState(false);
    const [novationDate, setNovationDate] = useState(randomDate);
    const [errors, setErrors] = useState({});
    const [viewProgress, setViewProgress] = useState(false);
    const [paymentLink, setPaymentLink] = useState(null);
    const [copied, setCopied] = useState(false);
    const [openBackdrop, setOpenBackdrop] = useState(false);


    const getInfoRole = async (doc) => {
        try {
            let response = await HttpRequest.getInfoRole(doc);
            return response.message;
        } catch (error) {
            console.log(error);
            return {}
        }
    }

    const cleanNumber = (str) => {
        // Eliminar comas y puntos
        const cleanedStr = str.replace(/[,.]/g, '');
        return cleanedStr;
    };

    const validateInputs = (setErrors, data) => {

        const newErrors = {};
        const validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
        const isNumeric = /^\d+$/;

        if (!data.cellPhone || data.cellPhone === '') {
            newErrors.cellPhone = 'El número de telefono es requerido.';
        }

        if (data.cellPhone.length > 10 || data.cellPhone.length < 10) {
            newErrors.cellPhone = 'El número de telefono es inválido, debe contener 10 números.';
        }

        if (!data.email || data.email === '') {
            newErrors.email = 'El email es requerido.';
        }

        if (!data.document || data.document === '') {
            newErrors.document = 'El documento es requerido.';
        }

        if (!data.fullName || data.fullName === '') {
            newErrors.fullName = 'El nombre completo es requerido.';
        }

        if (!data.description || data.description === '') {
            newErrors.description = 'La descripción es requerida.';
        }

        if (!data.amount || data.amount === '') {
            newErrors.amount = 'El valor a pagar es inválido.';
        }

        if (!validEmail.test(data.email)) {
            newErrors.email = 'El email es inválido.';
        }

        if (!isNumeric.test(data.document)) {
            newErrors.document = 'El documento es inválido.';
        }

        if (!isNumeric.test(data.cellPhone)) {
            newErrors.cellPhone = 'El telefono es inválido.';
        }

        if (!isNumeric.test(data.amount)) {
            newErrors.amount = 'El valor a pagar es inválido, debe contener solo números.';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0; // Devuelve true si no hay errores
    }

    const handleOpenAlert = (type, message, isOpen) => {
        if (type === 'success') {
            setMessageAlert(message);
            setIsOpenSuccess(isOpen);
            setViewalert(true);
        }
        if (type === 'error') {
            setMessageAlert(message);
            setIsOpenError(isOpen);
            setViewalert(true);
        }
    }

    const handleClearStateAlert = () => {
        setViewalert(false);
        setMessageAlert("");
        setIsOpenSuccess(false);
        setIsOpenError(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleChangeSwitch = (event) => {
        let cupo = 200000;
        setNovation(event.target.checked);
        if (!event.target.checked) {
            setNovationDate(randomDate);
        }
    };

    const handleToBack = () => {
        setErrors({});
        setPaymentLink(null);
        setCopied(false);
    };

    const handleSubmit = async (e) => {

        handleClearStateAlert();
        e.preventDefault();
        if (!validateInputs(setErrors, formData)) return;

        if (novation) {
            let fechas = calcularFechas();
            let dateNew = fechas.fecha2.format("DD/MM/YYYY");
            setNovationDate(dateNew);
        };

        formData.amount = cleanNumber(formData.amount);
        formData.cellPhone = cleanNumber(formData.cellPhone);
        formData.cellPhone = "+57" + formData.cellPhone;

        let paylaod = { ...formData, references: [formData.references] };
        let concatExtendPayData = `${novation};${novationDate};${paylaod.document}`;
        setViewProgress(true);

        try {
            let { error, message } = await CobreService.generatePaymentLink(
                {
                    payload: paylaod,
                    additionalData: { concatExtendPayData: btoa(concatExtendPayData) },
                    creditId: formData.references
                }
            );
            if (error === false) {
                let linkUrlCobre = message?.linkUrl;
                setPaymentLink(linkUrlCobre);
                handleOpenAlert('success', 'Link generado exitosamente!', true);
                setFormData({
                    cellPhone: '',
                    email: '',
                    amount: '',
                    document: '',
                    documentType: 'CC',
                    expirationDate: moment().format("YYYY-MM-DD"),
                    fullName: '',
                    description: 'Pago de crédito #',
                    references: [],
                    notificationMethods: ['ONLINE'],
                    redirectUrl: variablesGlobales.urlRedirectCobre,
                    enabledPaymentMethods: ["PSE", "BANCOLOMBIA", "NEQUI"],
                    currency: 'COP'
                });
            } else {
                handleOpenAlert('error', message?.message, true);
            }
        } catch (error) {
            console.log(error);
            handleOpenAlert('error', error.message, true);
        } finally {
            setViewProgress(false);
        }

        setTimeout(() => {
            handleClearStateAlert()
        }, 6000);
    }

    const handleCopyToClipboard = async () => {
        await navigator.clipboard.writeText(paymentLink);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 20000);
        return;
    };

    const handleGetData = async () => {
        try {
            if (!formData.document || formData.document.length === 0) return setErrors({ ...errors, document: 'Debe ingresar el documento' });
            setOpenBackdrop(true);
            let { data } = await apiClient.get(GET_DATA_BY_GENERATE_PAYMENT_LINK, { documento: formData.document });
            if (data?.success === true && data?.info) {
                let info = data.info;
                setFormData({
                    ...formData,
                    cellPhone: info.phone,
                    email: info.email,
                    amount: info.amount,
                    description: 'Pago de crédito #' + info?.creditId,
                    references: [info?.creditId],
                    fullName: info?.fullName,
                });
            } else {
                handleOpenAlert('error', 'No se encontró información del usuario.', true);
            }
        } catch (error) {
            console.log(error);
            handleOpenAlert('error', 'Error al consultar el usuario.', true);
        } finally {
            setOpenBackdrop(false);
        }
    };

    useEffect(() => {
        let doc = localStorage.getItem('doc');
        if (typeof doc !== 'string') {
            return navigate('/ingresar');
        } else {
            getInfoRole(doc)
                .then((infoRole) => {
                    if (infoRole?.error === true) return navigate('/ingresar');
                    if ('user' in infoRole) {
                        let user = infoRole.user;

                        if (user?.roleUser === roleUser.admin) {
                            console.log('User authorized...');

                        } else {
                            alert('No esta autorizado para ver esta página.');
                            setTimeout(() => {
                                return navigate('/ingresar');
                            }, 2000);
                        }
                    } else {
                        return navigate('/ingresar');
                    }
                })
                .catch(e => console.log(e))
        }
    }, []);

    return (
        <Fragment>

            {
                viewalert &&
                <>
                    <SuccessAlert isOpen={isOpenSuccess} message={messsageAlert}></SuccessAlert>
                    <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
                </>
            }

            {
                openBackdrop && <Backdrop open={openBackdrop}></Backdrop>
            }

            <DashboardsBackOffice
                name={'Admin'}
                balance={0}
                current9={true}
                title={'Generar link de pago (Cobre)'}
                main={
                    <>
                        <form action="#" method="POST">
                            <div className='px-4 mt-3 py-5 bg-white sm:p-6' style={{ borderRadius: '5px' }}>

                                <div className="grid grid-cols-8 gap-6">

                                    <div className="col-span-3 sm:col-span-3 mt-4">
                                        <label
                                            htmlFor="document"
                                            className="block text-sm font-medium"
                                        >
                                            Documento de identidad
                                        </label>
                                        <div>
                                            <input
                                                value={formData.document}
                                                onChange={handleChange}
                                                type="number"
                                                name="document"
                                                id="document"
                                                maxLength="40"
                                                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                            />
                                        </div>
                                        {errors.document && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.document}</span>)}
                                    </div>

                                    <div className='col-span-1' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                        <DocumentMagnifyingGlassIcon
                                            data-tip="React-tooltip"
                                            data-for="get-data"
                                            onClick={handleGetData}
                                            aria-hidden="true"
                                            className="h-5 w-5 text-gray-400 cursor-pointer" />
                                        <ReactTooltip
                                            place="top"
                                            id="get-data"
                                            type="dark"
                                            effect="solid"
                                        >
                                            Obtener información del usuario
                                        </ReactTooltip>
                                    </div>
                                </div>

                                <div className="col-span-4 sm:col-span-4 mt-4">
                                    <label
                                        htmlFor="fullName"
                                        className="block text-sm font-medium"
                                    >
                                        Nombre completo
                                    </label>
                                    <div>
                                        <input
                                            disabled={true}
                                            value={formData.fullName}
                                            onChange={handleChange}
                                            type="text"
                                            name="fullName"
                                            id="fullName"
                                            maxLength="100"
                                            className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                        />
                                    </div>

                                    {errors.fullName && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.fullName}</span>)}

                                    <div className="col-span-4 sm:col-span-4 mt-4">
                                        <label
                                            htmlFor="cellPhone"
                                            className="block text-sm font-medium"
                                        >
                                            Telefono
                                        </label>
                                        <div>
                                            <input
                                                disabled={true}
                                                value={formData.cellPhone}
                                                onChange={handleChange}
                                                type="text"
                                                name="cellPhone"
                                                id="cellPhone"
                                                maxLength="13"
                                                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                            />
                                        </div>
                                        {errors.cellPhone && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.cellPhone}</span>)}
                                    </div>

                                </div>



                                <div className="grid grid-cols-8 gap-6">
                                    <div className="col-span-4 sm:col-span-4 mt-4">
                                        <label
                                            htmlFor="email"
                                            className="block text-sm font-medium"
                                        >
                                            Email
                                        </label>
                                        <div>
                                            <input
                                                disabled={true}
                                                value={formData.email}
                                                onChange={handleChange}
                                                type="email"
                                                name="email"
                                                id="email"
                                                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                            />
                                        </div>
                                        {errors.email && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.email}</span>)}
                                    </div>


                                    <div className="col-span-4 sm:col-span-4 mt-4">
                                        <label
                                            htmlFor="description"
                                            className="block text-sm font-medium"
                                        >
                                            Descripción
                                        </label>
                                        <div>
                                            <input
                                                disabled={true}
                                                value={formData.description}
                                                onChange={handleChange}
                                                type="text"
                                                name="description"
                                                id="description"
                                                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                                placeholder='Pago de crédito #'
                                            />
                                        </div>
                                        {errors.description && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.description}</span>)}
                                    </div>

                                </div>


                                <div className="grid grid-cols-8 gap-6">
                                    <div className="col-span-4 sm:col-span-4 mt-4">
                                        <label
                                            htmlFor="email"
                                            className="block text-sm font-medium"
                                        >
                                            Referencia
                                        </label>
                                        <div>
                                            <input
                                                disabled={true}
                                                value={formData.references}
                                                onChange={handleChange}
                                                type="text"
                                                name="references"
                                                id="references"
                                                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                                placeholder='Colocar el id del crédito'
                                            />
                                        </div>
                                    </div>


                                    <div className="col-span-4 sm:col-span-4 mt-4">
                                        <label
                                            htmlFor="description"
                                            className="block text-sm font-medium"
                                        >
                                            Valor a pagar
                                        </label>
                                        <div>
                                            <input
                                                value={formData.amount}
                                                onChange={handleChange}
                                                type="number"
                                                name="amount"
                                                id="amount"
                                                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                                placeholder='Ej: 271525'
                                            />
                                        </div>
                                        {errors.amount && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.amount}</span>)}
                                    </div>

                                </div>

                                <div className="grid grid-cols-8 gap-6">
                                    <div className="col-span-4 sm:col-span-4 mt-4">
                                        <label
                                            htmlFor="email"
                                            className="block text-sm font-medium"
                                        >
                                            Es una novación?
                                        </label>
                                        <div>
                                            <FormControlLabel className="block text-sm font-medium" control={<Switch onChange={handleChangeSwitch} />} />
                                        </div>
                                    </div>

                                </div>

                                <div className="md:w-56 pt-3 mt-3">

                                    {viewProgress ? (
                                        <Fragment>
                                            <ProgressLinear></ProgressLinear>
                                            <p>Generando link de pago...</p>
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            {
                                                paymentLink ? (
                                                    <Fragment>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <span>{paymentLink}</span>
                                                            <span className="ml-3 hidden sm:block">
                                                                <button
                                                                    onClick={handleCopyToClipboard}
                                                                    type="button"
                                                                    className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-inset ring-gray-300 hover:bg-gray-50"
                                                                    style={{ border: '1px solid grey' }}
                                                                >
                                                                    {
                                                                        copied ? (
                                                                            <Tooltip title="Copiado!" placement="top">
                                                                                <CheckIcon aria-hidden="true" className="h-5 w-5" style={{ color: 'green' }} />
                                                                            </Tooltip>
                                                                        ) :
                                                                            (
                                                                                <Tooltip title="Copiar al portapapeles" placement="top">
                                                                                    <LinkIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                                                                                </Tooltip>
                                                                            )
                                                                    }

                                                                </button>
                                                            </span>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', paddingTop: '0.5em', marginTop: '0.5em' }}>
                                                            <button
                                                                onClick={handleToBack}
                                                                type="button"
                                                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-xl font-medium text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-none"
                                                            >
                                                                <div className="flex">
                                                                    {'Atrás'}
                                                                    <div className="grid content-center pl-2">{ }</div>
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </Fragment>
                                                ) :
                                                    (
                                                        <button
                                                            onClick={handleSubmit}
                                                            type="button"
                                                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-xl font-medium text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-none"
                                                        >
                                                            <div className="flex">
                                                                {'Generar link'}
                                                                <div className="grid content-center pl-2">{ }</div>
                                                            </div>
                                                        </button>
                                                    )
                                            }

                                        </Fragment>
                                    )}

                                </div>
                            </div>
                        </form>

                    </>
                }
            />

        </Fragment>
    );
}
